import {
  Component,
  ViewChild,
  ElementRef,
  HostListener,
  Renderer2,
  OnDestroy,
  Inject,
  NgZone,
  inject,
  PLATFORM_ID,
  CUSTOM_ELEMENTS_SCHEMA, AfterViewInit,
  OnInit,
  ViewContainerRef,
  ComponentRef,
} from '@angular/core';
import { CommonModule, DOCUMENT, Location } from '@angular/common';
import swal from 'sweetalert2';
import { Meta, Title } from '@angular/platform-browser';
import { ApidataService } from '../apidata.service';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  HttpClient,
  HttpClientModule,
  HttpHeaders,
} from '@angular/common/http';
import { Router, NavigationEnd } from '@angular/router';
import { RouterModule } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ChangeDetectorRef } from '@angular/core';
import { environment } from '../../environments/environments';
import { FeedbackComponent } from '../feedback/feedback.component';
import { IconsFreeToolsComponent } from '../icons-free-tools/icons-free-tools.component';
import { QuillModule } from 'ngx-quill';
import Quill from 'quill';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';
import { LinkService } from '../services/link.service';
import { SeoTagsService } from '../services/seo-tags.service';
import { LanderComponent } from '../grammarchecker/additional/lander.component';

import { PremiumComponent } from "../premium/premium.component";
import { PremiumModalStartupComponent } from '../premium-modal/premium-modal.component';
declare var Dropbox: any;
declare var $: any;
declare var window: any;
declare var gapi: any;
declare var google: any;

interface RouteSEOData {
  title?: string;
  ogImage?: string;
  ogTitle?: string;
  ogDescription?: string;
  twittertitle?: string;
  twitterdescription?: string;
  [key: string]: any;
}
@Component({
  selector: 'app-grammarchecker',
  standalone: true,
  imports: [
    HeaderComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    FooterComponent,
    RouterModule,
    FeedbackComponent,
    IconsFreeToolsComponent,
    QuillModule,
    PremiumComponent,
    PremiumModalStartupComponent,
    LanderComponent,
    TranslateModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [ApidataService],
  templateUrl: './grammarchecker.component.html',
  styleUrl: './grammarchecker.component.css',
})
export class GrammarcheckerComponent implements OnInit, AfterViewInit, OnDestroy {
  private platformId = inject(PLATFORM_ID);
  private ngZone = inject(NgZone);
  activeTab: string = '';
  showonlydrive: boolean = false;
  spellingmistake = 0;
  garmmarmistake = 0;
  captchaToken: string | null = null;

  recaptcha_message = '';

  public color: string = 'black';
  public form_message: any;
  public form_email: any;
  public showfeedbackloader: boolean = false;
  public esubText: string = '';
  public esubText2: string = '';
  selectedValue: number;
  eFsubText2: any;
  public eFsubIF: boolean = false;
  public char_count = 0;
  word_count = 0;
  public spanwords = [];
  public gotresponse: boolean = false;
  public editortext = '';
  public showbuttons: boolean = false;
  public loaderAlert: boolean = false;
  public menuafterresponse: boolean = false;
  public copiedtext: boolean = false;
  public copried_txt: string = '';
  public EdittorHeight: any;
  public EdittorWidth: any;
  error: boolean = false;
  errorAlerts;
  success: boolean = false;
  successAlert;
  isMenuDropdownVisible = false;
  selectenglishlanguage = true;
  // selectedLanguage = {
  //   name: 'British',
  //   icon: '../../assets/images/flag/British.svg',
  // };
  public intentbtn: boolean = true;
  public describebtn: boolean = false;
  public conviencebtn: boolean = false;
  public tellbtn: boolean = false;
  public googledriveword = 0;
  public settargetvalue: boolean = false;
  public copylinkture: boolean = false;
  selectuslanaguge: boolean = true;
  selectuklanague: boolean = false;
  selectcalanaguage: boolean = false;
  selectaulanaguge: boolean = false;
  isTooltipVisible = false;
  activeButton: string = 'academic';
  showAcademic: boolean = false;
  formality: string = 'formal';
  intent: string = 'inform';
  public formvalueset: boolean = false;
  public changeformalbg: boolean = true;
  public formalityvalue = '';
  public homeText = '';
  public doc_id = '';
  public cookieValue = '';
  public get_socket_object;
  showError: boolean = false;
  isModalOpen: boolean = false;
  isOpenModal: boolean = false;
  isDropdownOpensuggestion = true;
  openlanguage = true;
  suggestion_color = '';
  isDropdownOpen = true;
  got_recpatcha: boolean = false;
  recaptchaWidgetId: number | undefined;
  languages = [
    { name: 'British', icon: '../../assets/images/flag/British.svg' },
    { name: 'American', icon: '../../assets/images/flag/American.svg' },
    { name: 'Canadian', icon: '../../assets/images/flag/Canadian.svg' },
    { name: 'Australian', icon: '../../assets/images/flag/Australian.svg' },
  ];

  constructor(
    private cdr: ChangeDetectorRef,
    private renderer: Renderer2,
    private sanitizer: DomSanitizer,
    @Inject(DOCUMENT) private documenta: Document,
    private webservices: ApidataService,
    private el: ElementRef,
    private router: Router,
    private https: HttpClient,
    private meta: Meta,
    private titleService: Title,
    private route: ActivatedRoute,
    private title: Title,
    private translate: TranslateService,
    public languageService: LanguageService,
    private linkService: LinkService,
    private seoService: SeoTagsService,
    private viewContainerRef: ViewContainerRef
  ) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });

    this.translate.setDefaultLang('en');
  }
  private scriptElement: HTMLScriptElement | undefined;

  ngOnInit(): void {
    this.loadEditor();
    this.char_count = $('#editor').text().length;
    this.word_count = $('#editor').text().split(/\s+/).length;
    if (this.captchaVisible) {
      this.loadAndRenderTurnstile();
    }

    // this.titleService.setTitle('Grammar Checker Free - (Grammar Editor)');
    // this.meta.addTags([
    //   {
    //     name: 'description',
    //     content:
    //       'Write with confidence using our free grammar checker. Perfect your grammar style and word choice to eliminate errors in seconds. No sign-up Required.',
    //   },
    //   { name: 'title', content: '{{Grammar Checker Free - (Grammar Editor)}}' },
    //   { property: 'og:image:alt', content: 'Grammar Checker' },
    // ]);


    this.seoService.updatePageMeta('meta-data-grammarChecker');


    this.scriptElement = this.renderer.createElement('script');
    this.scriptElement.type = 'application/ld+json';
    this.scriptElement.text = `
      {
        "@context": "https://schema.org",
        "@type": "WebApplication",
        "name": "Free Grammar Checker",
        "url": "https://www.grammarin.com/grammar-checker",
        "operatingSystem": "Windows & Android",
        "applicationCategory": "https://schema.org/WebApplication",
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "5",
          "ratingCount": "6391"
        },
        "offers": {
          "@type": "Offer",
          "price": "Free",
          "priceCurrency": "USD"
        }
      }
    `;
    this.renderer.appendChild(this.documenta.head, this.scriptElement);
    const existingCanonical = document.querySelector("link[rel='canonical']");
    if (existingCanonical) {
      existingCanonical.setAttribute(
        'href',
        'https://www.grammarin.com/grammar-checker'
      );
    } else {
      const link: HTMLLinkElement = this.renderer.createElement('link');
      link.setAttribute('rel', 'canonical');
      link.setAttribute('href', 'https://www.grammarin.com/grammar-checker');
      this.renderer.appendChild(document.head, link);
    }
    $('.tab_content').hide();
    $('.tab_content:first').show();

    $('ul.tabs li').click(function () {
      $('.tab_content').hide();
      var activeTab = $(this).attr('rel');
      $('#' + activeTab).fadeIn();

      $('ul.tabs li').removeClass('active');
      $(this).addClass('active');

      $('.tab_drawer_heading').removeClass('d_active');
      $(".tab_drawer_heading[rel^='" + activeTab + "']").addClass('d_active');
    });
    $('.tab_container').css('min-height', function () {
      return $('.tabs').outerHeight() + 50;
    });
    $('.tab_drawer_heading').click(function () {
      $('.tab_content').hide();
      var d_activeTab = $(this).attr('rel');
      $('#' + d_activeTab).fadeIn();

      $('.tab_drawer_heading').removeClass('d_active');
      $(this).addClass('d_active');

      $('ul.tabs li').removeClass('active');
      $("ul.tabs li[rel^='" + d_activeTab + "']").addClass('active');
    });

    this.activeTab = 'q1';

    const path = this.getLocalizedImagePath('grammar-checker');
    // console.log('Localized Image Path:', path);

    this.route.data.subscribe((data: RouteSEOData) => {
      if (!data || !data.ogImage) {
        console.warn('Route data or ogImage not found!');
        return;
      }

      const langCode = this.languageService.selectedLanguage?.code || 'en';
      const baseOgImage = data.ogImage;

      const localizedOgImage =
        langCode === 'en'
          ? baseOgImage
          : baseOgImage.replace('.png', `-${langCode}.png`);

      // console.log('langCode:', langCode);
      // console.log('OG Image Base:', baseOgImage);
      // console.log('Localized OG Image:', localizedOgImage);

      this.meta.updateTag({ property: 'og:image', content: localizedOgImage });
    });


    const langCode = this.languageService.getLanguageFromUrl(this.router.url);
    const lang = this.languageService.languages.find(
      (l) => l.code === langCode
    );
    if (lang) {
      this.languageService.setLanguage(lang);
    }

    this.languageService.selectedLanguage$.subscribe((language) => {
      this.selectedLanguage = language;
      this.translate.use(language.code);
    });

    const storedLanguage = localStorage.getItem('selectedLanguage');

    if (storedLanguage) {
      this.selectedLanguage = JSON.parse(storedLanguage);
      this.translate.use(this.selectedLanguage.code);
    } else {
      // this.translate.use('en');
    }
    // Ahref Langs
    // this.linkService.addAlternateLink('x-default', 'https://www.grammarin.com/grammar-checker');
    // this.linkService.addAlternateLink('en', 'https://www.grammarin.com/grammar-checker');
    // this.linkService.addAlternateLink('pt', 'https://www.grammarin.com/pt/grammar-checker');
    // this.linkService.addAlternateLink('es', 'https://www.grammarin.com/es/grammar-checker'); uncomment when localize the page
    // Ahref Langs

    // const canonicalUrl = `https://www.grammarin.com/${langCode}/grammar-checker`;
    // this.seoService.setCanonicalUrl(canonicalUrl);  uncomment when localize the page 
  }
  selectedLanguage: any;
  defaultLanguage = {
    name: 'English ',
    icon: '/assets/images/plagiarism checker1/language.svg',
    code: 'en',
  };
  ////// hidden recaptcha strat
  captchaVisible: boolean = false;
  isCaptchaVerified: boolean = false;
  recaptchaMessage: string = '';

  handleButtonClick(): void {
    if (this.loaderAlert) {
      return;
    }
    $('#editor').find('span').contents().unwrap();
    this.char_count = $('#editor').text().length;
    this.word_count = $('#editor')
      .text()
      .trim()
      .split(/\s+/)
      .filter((word) => word.length > 0).length;

    if (this.word_count === 0) {
      // this.showAlert('Error: Please add at least 1 word to proceed.', '');
      this.translate
        .get('alerts.one-word')
        .subscribe((translatedMsg: string) => {
          this.showAlert(translatedMsg, '');
        });
      return;
    }

    if (this.isCaptchaVerified) {
      this.saveTextRedirect();
    } else {
      if (!this.captchaVisible) {
        this.captchaVisible = true;
        this.cdr.detectChanges();
        this.loadAndRenderTurnstile();
      } else {
        this.recaptchaMessage = 'Please complete the CAPTCHA.';
        this.color = '#721c24';
      }
    }
  }

  loadAndRenderTurnstile(): void {
    if (typeof window['turnstile'] === 'undefined') {
      const script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
      script.async = true;
      script.defer = true;
      script.onload = () => this.renderTurnstile();
      script.onerror = () =>
        // console.error('Failed to load Turnstile script.');
        document.body.appendChild(script);
    } else {
      this.renderTurnstile();
    }
  }

  renderTurnstile(): void {
    const containerElement = document.getElementById('recaptcha-container');
    if (!containerElement) {
      // console.error('Container element not found.');
      return;
    }

    window['turnstile'].render(containerElement, {
      sitekey: environment.CaptchaKey,
      size: 'normal',
      callback: (token: string) => this.onTurnstileSuccess(token),
      'error-callback': () => this.onTurnstileError(),
    });
    // console.log('Turnstile rendered successfully.');
  }

  onTurnstileSuccess(token: string): void {
    // console.log('Turnstile token received:', token);
    this.captchaToken = token;
    this.isCaptchaVerified = true;
    this.captchaVisible = false;
    this.recaptchaMessage = '';
    this.saveTextRedirect();
  }

  onTurnstileError(): void {
    // console.error('Turnstile error occurred.');
    this.captchaToken = null;
    this.recaptchaMessage = 'CAPTCHA verification failed. Please try again.';
    this.color = '#721c24';
  }

  resetTurnstile(): void {
    const containerElement = document.getElementById('recaptcha-container');
    if (typeof window['turnstile'] !== 'undefined') {
      window['turnstile'].reset(containerElement);
    } else {
      // console.error('Turnstile library not loaded.');
    }
  }

  ///// recaptcha end

  // Custom toolbar configuration

  editorModules = {
    toolbar: false,
  };

  ngOnDestroy(): void {
    if (this.scriptElement) {
      this.renderer.removeChild(this.documenta.head, this.scriptElement);
    }
  }
  toggleTab(tabId: string): void {
    if (this.activeTab === tabId) {
      this.activeTab = '';
    } else {
      this.activeTab = tabId;
    }
  }
  selectedTab: string = 'tab1';
  selectTab(tab: string): void {
    this.selectedTab = tab;
  }
  public cleartxtbtn: boolean = false;

  public gcrouteto() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.router.navigate(['/grammar-checker']);
  }
  public grouteto() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.router.navigate(['']);
  }
  public prouteto() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.router.navigate(['/plagiarism-checker']);
  }

  editorTxtAI: string;

  textfromAI() {
    if (localStorage.getItem('editorValueAI')) {
      this.showParagraph = false;
    }
    setTimeout(() => {
      if (localStorage.getItem('editorValueAI')) {
        this.editorTxtAI = localStorage.getItem('editorValueAI');
        this.char_count = this.editorTxtAI.length;
        this.word_count = this.editorTxtAI.trim().split(/\s+/).length;
        localStorage.removeItem('editorValueAI');

        if (this.editorTxtAI != null && this.editorTxtAI.length !== 0) {
          this.textDivRef.nativeElement.innerHTML = this.editorTxtAI;
        }
      }
    }, 1000);
  }
  pcroute() {
    var editortxt = '';
    editortxt = $('#editor2').text();
    localStorage.setItem('editorValueAI', editortxt);
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/plagiarism-checker'])
    );
    window.open(url, '_blank');
  }
  gcroute() {
    var editortxt = '';
    editortxt = $('#editor2').text();
    localStorage.setItem('editorValueAI', editortxt);
    const url = this.router.serializeUrl(this.router.createUrlTree(['']));
    window.open(url, '_blank');
  }

  // sampletext() {
  //   const newText =
  //     "This is example of how people writes when their grammar are not good. Many times, user forgets add article or put comma where not need it. Some person think grammar it's not important but it make reading harder and confusing more. If your write fastly or don't check what you wrote, mistake happens easily. On our website, there is many tools for help, like plagiarism detector, article rewriter, parapharse tool and summarize also. This tool helps you write more better and make your content looks professionaly.We all are aware of the fact that plagiarism can destroy our careers and websites' credibility.  There is plagiarism, but only some platforms will provide you with the quality Grammarin offers. This article is jam-packed with top-notch features to facilitate you in the best way possible.";

  //   if (this.quill) {
  //     this.quill.root.innerHTML = newText;
  //   }

  //   this.homeText = newText;

  //   setTimeout(() => {
  //     this.char_count = this.quill.getText().length;
  //     this.word_count = this.quill.getText().trim().split(/\s+/).length;
  //   }, 100);
  //   this.showParagraph = false;
  // }

  sampletext() {
    this.translate
      .get('samplemethod-grammarPage.samplemethoddetail')
      .subscribe((localizedText: string) => {
        if (this.quill) {
          this.quill.root.innerHTML = localizedText;
        }

        this.homeText = localizedText;

        setTimeout(() => {
          this.char_count = this.quill.getText().length;
          this.word_count = this.quill.getText().trim().split(/\s+/).length;
        }, 100);

        this.showParagraph = false;
      });
  }

  // SCROL
  shouldShowButton: boolean = false;
  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (window.pageYOffset > 200) {
      this.shouldShowButton = true;
    } else {
      this.shouldShowButton = false;
    }
  }
  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  showParagraph: boolean = true;
  @ViewChild('text') text: ElementRef;

  isPopupOpen = false;
  public clientId =
    '859452103362-3aroha97qk7nt8ps6ocl70k10pj7uuvt.apps.googleusercontent.com';
  public scope = [
    'profile',
    'email',
    'https://www.googleapis.com/auth/drive.file',
  ].join(' ');
  public pickerApiLoaded = false;
  public oauthToken?: any;
  @ViewChild('fileInput') fileInput;
  @ViewChild('editor') editor!: ElementRef<HTMLDivElement>;

  showAlert(message, selector) {
    this.errorAlerts = message;
    $(selector).css('border-color', 'red');
    this.error = true;
    $('#errorAlerts').show();
    setTimeout(() => {
      $('#errorAlerts').hide();
      $(selector).css('border-color', '#e7e7ec');
      this.error = false;
    }, 4000);
  }

  showSuccess(message, selector) {
    this.successAlert = message;
    this.success = true;
    $('#successAlert').show();
    setTimeout(() => {
      $('#successAlert').hide();
      $(selector).css('border-color', '#e7e7ec');
      this.success = false;
    }, 4000);
  }

  closeErrorDiv() {
    this.error = false;
  }

  getElementHeightById(id: string): void {
    const element = this.el.nativeElement.querySelector(`#${id}`);
    if (element) {
      this.EdittorHeight = element.clientHeight;
      this.EdittorWidth = element.clientWidth;
    } else {
    }
  }
  ////////////// Upload file function from browser //////////
  public uploadFileSaveRedirect(event): void {
    $('#UpFileModal').modal({ backdrop: 'static', keyboard: false });

    const files: FileList = this.fileInput.nativeElement.files;
    var filetype = 'pdf';
    if (files[0].size > 5243000) {
      // this.showAlert('File should be less than 5 MB.', '');
      this.translate
        .get('alerts.fileSizeLimit')
        .subscribe((translatedMsg: string) => {
          this.showAlert(translatedMsg, '');
        });
    } else {
      let input = event.target;
      this.menuafterresponse = false;
      this.gotresponse = false;
      this.loaderAlert = true;
      this.showParagraph = true;
      this.char_count = 0;
      this.showbuttons = false;
      this.showParagraph = false;

      $('.hideUpload').hide('slow');
      this.webservices.uploadfilefrombrowser(files).subscribe(
        (data) => {
          this.loaderAlert = false;
          let receivedData = data;
          $('.ql-editor').html(receivedData['RetCnt'].replace(/\n/g, '<br>'));
          this.getContent('', receivedData['RetCnt']);
          this.fileInput.nativeElement.value = '';
        },
        (error) => {
          this.loaderAlert = false;

          // this.showAlert(
          //   'Unable to proceed with a password protected file.',
          //   ''
          // );
          this.translate
            .get('alerts.Unable-to-proceed')
            .subscribe((translatedMsg: string) => {
              this.showAlert(translatedMsg, '');
            });
        }
      );
    }
  }
  /// dropbox  gDriveUpload functionn////////

  public gDriveUpload() {
    gapi.load('auth', { callback: this.onAuthApiLoad.bind(this) });
    gapi.load('picker', { callback: this.onPickerApiLoad.bind(this) });
    setTimeout(() => {
      $('.ql-editor').click();
    }, 500);
  }

  public onAuthApiLoad() {
    gapi.auth.authorize(
      {
        client_id: this.clientId,
        scope: this.scope,
        immediate: false,
      },
      this.handleAuthResult
    );

    setTimeout(() => {
      $('.ql-editor').click();
    }, 500);
  }

  public onPickerApiLoad() {
    this.pickerApiLoaded = true;
  }

  public handleAuthResult(authResult) {
    $('#UpFileModal').modal('hide');
    let src;

    if (authResult && !authResult.error) {
      if (authResult.access_token) {
        let view = new google.picker.View(google.picker.ViewId.DOCS);
        view.setMimeTypes(
          'application/pdf,application/txt,text/plain,application/vnd.oasis.opendocument.text,application/vnd.google-apps.document,application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        );

        let pickerBuilder = new google.picker.PickerBuilder();
        let picker = pickerBuilder
          .enableFeature(google.picker.Feature.MINE_ONLY)
          .setOAuthToken(authResult.access_token)
          .addView(view)
          .addView(new google.picker.DocsUploadView())
          .setCallback(function (e) {
            if (e.action == google.picker.Action.PICKED) {
              var fileId = e.docs[0].id;
              var file = e.docs[0].url;
              var files = e.docs[0];
              if (files.sizeBytes > 5243000) {
                this.lodershow = false;

                swal({
                  background: '#FFFFFF',
                  title: 'Error',
                  html: `
                    <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
                      background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
                      <div class="text-center" style="margin-top: 9%;">
                        <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
                        <div style="width: 323px; height: 64px; margin-left: 77px;">
                          <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
                            
                             this.translate
        .get('alerts.fileSizeLimit')
        .subscribe((translatedMsg: string) => {
          this.showAlert(translatedMsg, '');
        });
                          </p>
                        </div>
                        <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
                          border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
                          class="mt-4 butn-alert">Ok</button>
                      </div>
                    </div>
                  `,
                  showConfirmButton: false,
                  width: '323px',
                  timer: 4000,
                });

                setTimeout(() => {
                  const okButton = document.getElementById('swal-ok-button');
                  if (okButton) {
                    okButton.addEventListener('click', () => {
                      swal.close();
                    });
                  }
                }, 0);
              } else {
                if (e.docs[0].name.split('.')[1] === 'pdf') {
                  let filelink2 = file + fileId;
                  let linksvalue =
                    'https://drive.google.com/u/0/uc?id=' +
                    fileId +
                    '&export=download';
                  let profile_id = localStorage.getItem('profile_id');
                  $.ajax({
                    url: environment.API_URL + '/api/downloadFromDrive',
                    type: 'post',

                    dataType: 'json',
                    data: {
                      profile_id: profile_id,
                      hash: authResult.access_token,
                      file_path: fileId,
                      file_type: 'pdf',
                      create_chunks: 'false',
                    },
                    beforeSend: function (xhr) {
                      xhr.setRequestHeader(
                        'Authorization',
                        +localStorage.getItem('token')
                      );
                    },

                    success: function (return_data) {
                      $('.ql-editor').html(
                        return_data.RetCnt.replace(/&quot;/g, '"')
                          .replace(/&#x27;/g, "'")
                          .replace(/&amp;/g, /&/g)
                          .replace(/&gt;/g, '>')
                          .replace(/&lt;/g, '<')
                          .replace(/&quot;/g, /"/g)
                          .replace(/\n/g, '<br>')
                      );
                      this.homeText = return_data.RetCnt.replace(/\n/g, '<br>');

                      setTimeout(() => {
                        $('.ql-editor').click();
                      }, 500);
                    },
                    error: function (data) {
                      swal({
                        background: '#FFFFFF',
                        title: 'Error',
                        html: `
        <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
          background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
          <div class="text-center" style="margin-top: 9%;">
            <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
            <div style="    width: 369px; height: 64px; margin-left: 39px;">
              <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
                This file is restricted. Update the public access of your file from \"Restricted\" to \"Anyone with the link.\"
              </p>
            </div>
            <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
              border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
              class="mt-5 butn-alert">Ok</button>
          </div>
        </div>
      `,
                        showConfirmButton: false,
                        width: '323px',
                        timer: 4000,
                      });

                      setTimeout(() => {
                        const okButton =
                          document.getElementById('swal-ok-button');
                        if (okButton) {
                          okButton.addEventListener('click', () => {
                            swal.close();
                          });
                        }
                      }, 0);
                    },
                  });
                } else if (e.docs[0].name.split('.')[1] === 'txt') {
                  let filelink2 = file + fileId;
                  let linksvalue =
                    'https://drive.google.com/u/0/uc?id=' +
                    fileId +
                    '&export=download';

                  if (localStorage.getItem('profile_id')) {
                    var profile_id = localStorage.getItem('profile_id');
                  } else {
                    var profile_id = '1';
                  }
                  $.ajax({
                    url: environment.API_URL + '/api/downloadFromDrive',
                    type: 'post',

                    dataType: 'json',
                    data: {
                      profile_id: profile_id,
                      hash: authResult.access_token,
                      file_path: fileId,
                      file_type: 'txt',
                      create_chunks: 'false',
                    },
                    beforeSend: function (xhr) {
                      xhr.setRequestHeader(
                        'Authorization',
                        +localStorage.getItem('token')
                      );
                    },

                    success: function (return_data) {
                      this.hideothers = true;

                      $('.ql-editor').html(
                        return_data.RetCnt.replace(/&quot;/g, '"')
                          .replace(/&#x27;/g, "'")
                          .replace(/&amp;/g, /&/g)
                          .replace(/&gt;/g, '>')
                          .replace(/&lt;/g, '<')
                          .replace(/&quot;/g, /"/g)
                          .replace(/\n/g, '<br>')
                      );
                      this.homeText = return_data.RetCnt.replace(/\n/g, '<br>');

                      setTimeout(() => {
                        $('.ql-editor').click();
                      }, 500);
                    },
                    error: function (data) {
                      swal({
                        background: '#FFFFFF',
                        title: 'Error',
                        html: `
        <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
          background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
          <div class="text-center" style="margin-top: 9%;">
            <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
            <div style="    width: 369px; height: 64px; margin-left: 39px;">
              <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
                This file is restricted. Update the public access of your file from \"Restricted\" to \"Anyone with the link.\"
              </p>
            </div>
            <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
              border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
              class="mt-5 butn-alert">Ok</button>
          </div>
        </div>
      `,
                        showConfirmButton: false,
                        width: '323px',
                        timer: 4000,
                      });

                      setTimeout(() => {
                        const okButton =
                          document.getElementById('swal-ok-button');
                        if (okButton) {
                          okButton.addEventListener('click', () => {
                            swal.close();
                          });
                        }
                      }, 0);
                    },
                  });
                } else if (e.docs[0].name) {
                  let filelink2 = file + fileId;
                  let linksvalue =
                    'https://docs.google.com/feeds/download/documents/export/Export?id=' +
                    fileId +
                    '&exportFormat=docx';
                  let profile_id = localStorage.getItem('profile_id');
                  $.ajax({
                    url: environment.API_URL + '/api/downloadFromDrive',
                    type: 'post',

                    dataType: 'json',
                    data: {
                      profile_id: profile_id,
                      hash: authResult.access_token,
                      file_path: fileId,
                      file_type: 'docx',
                      create_chunks: 'false',
                    },
                    beforeSend: function (xhr) {
                      xhr.setRequestHeader(
                        'Authorization',
                        +localStorage.getItem('token')
                      );
                    },

                    success: function (return_data) {
                      $('.ql-editor').html(
                        return_data.RetCnt.replace(/&quot;/g, '"')
                          .replace(/&#x27;/g, "'")
                          .replace(/&amp;/g, /&/g)
                          .replace(/&gt;/g, '>')
                          .replace(/&lt;/g, '<')
                          .replace(/&quot;/g, /"/g)
                          .replace(/\n/g, '<br>')
                      );
                      this.homeText = return_data.RetCnt.replace(/\n/g, '<br>');

                      setTimeout(() => {
                        $('.ql-editor').click();
                      }, 500);
                    },
                    error: function (data) {
                      swal({
                        background: '#FFFFFF',
                        title: 'Error',
                        html: `
        <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
          background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
          <div class="text-center" style="margin-top: 9%;">
            <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
            <div style="    width: 369px; height: 64px; margin-left: 39px;">
              <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
                This file is restricted. Update the public access of your file from \"Restricted\" to \"Anyone with the link.\"
              </p>
            </div>
            <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
              border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
              class="mt-5 butn-alert">Ok</button>
          </div>
        </div>
      `,
                        showConfirmButton: false,
                        width: '323px',
                        timer: 4000,
                      });

                      setTimeout(() => {
                        const okButton =
                          document.getElementById('swal-ok-button');
                        if (okButton) {
                          okButton.addEventListener('click', () => {
                            swal.close();
                          });
                        }
                      }, 0);
                    },
                  });
                }
              }
            }
          })
          .build();
        picker.setVisible(true);
      }
    }
  }
  ////  gDriveUpload functionn

  //// dropbox   functionn
  openDropboxChooser(): void {
    const options = {
      success: (files: any) => {
        let fileType = this.getFileType(files[0].name);

        if (fileType === 'docx' || fileType === 'pdf' || fileType === 'txt') {
          this.uploadFileToServer(files[0].link, fileType);
        } else {
        }
      },
      cancel: () => { },
      linkType: 'direct',
      multiselect: false,
      extensions: ['.docx', '.pdf', '.txt'],
      sizeLimit: 1024 * 1024 * 5,
    };
    Dropbox.choose(options);
  }
  getFileType(fileName: string): string {
    const fileExtension = fileName.split('.').pop();
    return fileExtension ? fileExtension.toLowerCase() : '';
  }
  uploadFileToServer(fileLink: string, fileType: string): void {
    this.word_count = 0;
    this.char_count = 0;
    this.spellingmistake = 0;
    this.garmmarmistake = 0;
    this.menuafterresponse = false;
    this.showonlydrive = false;
    this.showParagraph = false;
    this.loaderAlert = true;
    const headers = new HttpHeaders({
      Authorization: environment.AuthorizationGIN,
    });
    var data = { file_type: fileType, file_path: fileLink };
    this.webservices.dropboxfile(fileType, fileLink).subscribe((data) => {
      let receivedData = data;
      $('.ql-editor').html(receivedData['RetCnt']);
      this.getContent('', receivedData['RetCnt']);
      this.loaderAlert = false;
    });
  }
  ///////////////////////////////////////////
  ////////////// clear text function //////////
  public clear_txt() {
    this.gotresponse = false;
    this.word_count = 0;
    this.char_count = 0;
    this.showParagraph = true;
    var testingnew = document.getElementById('editor');
    testingnew.textContent = '';
    this.showbuttons = false;
    this.loaderAlert = false;
    this.menuafterresponse = false;
  }

  onclickeditor(event: MouseEvent) {
    this.char_count = $('#editor').text().length;
    this.word_count = $('#editor').text().split(/\s+/).length;
    event.stopPropagation();
    if (this.char_count === 0 && !this.showParagraph) {
      this.word_count = 0;
      this.char_count = 0;
    }
    this.showParagraph = false;
    // const sampleText = 'Enter your Text Here OR Upload file from above options';
    const sampleText = this.translate.instant('alerts.Enter-Text');

    const editorContent = $('#editor').text().trim();
    if (editorContent === sampleText) {
      this.word_count = 0;
      this.char_count = 0;
    }
    if (editorContent === '') {
      this.word_count = 0;
      this.char_count = 0;
    } else {
      this.word_count = editorContent
        .split(/\s+/)
        .filter((word) => word.length > 0).length;
    }
  }

  @HostListener('document:click', ['$event.target'])
  onClickOutside(targetElement: HTMLElement) {
    if (!this.editor) {
      return;
    }

    const clickedElementId = targetElement.id;
    const excludedButtonIds = [
      'checkgrammar-btn-art',
      'downloadfile',
      'copy-btn',
      'retry-btn',
      'footerlinksforroute',
    ];
    const editorContent = this.editor.nativeElement.innerText.trim();
    if (editorContent !== '') {
      return;
    }

    if (excludedButtonIds.includes(clickedElementId)) {
      return;
    }

    if (!this.editor.nativeElement.contains(targetElement)) {
      if (!this.word_count || !this.char_count) {
        this.showParagraph = true;
      } else {
        this.showParagraph = false;
      }

      this.word_count = 0;
      this.char_count = 0;

      const editorText = this.editor.nativeElement.innerText.trim();
      this.word_count = editorText
        .split(/\s+/)
        .filter((word) => word.length > 0).length;
      this.char_count = editorText.length;
    }
  }
  copyText() {
    const editorElement = $('#editor2').get(0);
    if (editorElement) {
      const range = document.createRange();
      range.selectNode(editorElement);
      window.getSelection()?.removeAllRanges();
      window.getSelection()?.addRange(range);
      try {
        document.execCommand('copy');
        this.copiedtext = true;
        this.copried_txt = 'copied';
        $('#copytextId').hide();
        $('#copried_txt').show();
        setTimeout(function () {
          $('#copried_txt').hide();
          $('#copytextId').show();
          this.copiedtext = false;
        }, 2000);
      } catch (err) {
        this.copiedtext = false;
      }
      window.getSelection()?.removeAllRanges();
    }
  }
  downloadText() {
    const editorElement = $('#editor').get(0);
    if (editorElement) {
      const textContent = editorElement.innerText;
      const blob = new Blob([textContent], { type: 'text/plain' });
      const a = document.createElement('a');
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = 'text_file.txt';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }
  }
  public subscribed_user;
  public checkLogin = false;
  public ngAfterViewInit(): void {
    this.seoService.updatePageMeta('meta-data-grammarChecker');
    const langCode = this.languageService.selectedLanguage?.code || 'en';
    // const canonicalUrl = `https://www.grammarin.com/${langCode}/grammar-checker`;
    // this.seoService.setCanonicalUrl(canonicalUrl); uncomment when page localize 
    this.loadEditor();



    this.char_count = $('#editor').text().length;
    this.homeText = $('#editor').text();
    this.word_count = $('#editor').text().split(/\s+/).length;

    this.checkLogin = this.webservices.isLoggedIn();
    if (this.checkLogin) {
      this.profile_id = localStorage.getItem('profile_id');
    } else {
      this.profile_id = '1';
    }
    const storedStatus = JSON.parse(
      localStorage.getItem('premium_user_done') || 'false'
    );
    this.subscribed_user = storedStatus;

    this.getElementHeightById('editor');
    this.getBrowserWidth();
    $(window).scroll(function () {
      if ($(this).scrollTop() > 200) {
        $('#scroll-to-top').fadeIn('slow');
      } else {
        $('#scroll-to-top').fadeOut('slow');
      }
    });
    $('#scroll-to-top').click(function () {
      $('html, body').animate({ scrollTop: 0 }, 700);
      return false;
    });

    this.seoService.updateOgImage();

    // this.loadLanderComponent();
  }

  toggleMenuDropdown() {
    this.isMenuDropdownVisible = !this.isMenuDropdownVisible;
  }

  selectLanguage(languageName: string, languageIcon: string) {
    this.selectedLanguage = { name: languageName, icon: languageIcon };
    this.isMenuDropdownVisible = false;
  }

  public intenvalue() {
    this.describebtn = false;
    this.intentbtn = true;
    this.conviencebtn = false;
    this.tellbtn = false;
  }
  public describes() {
    this.describebtn = true;
    this.intentbtn = false;
    this.conviencebtn = false;
    this.tellbtn = false;
  }
  public convience() {
    this.conviencebtn = true;
    this.describebtn = false;
    this.intentbtn = false;
    this.tellbtn = false;
  }
  public tells() {
    this.tellbtn = true;
    this.conviencebtn = false;
    this.describebtn = false;
    this.intentbtn = false;
  }

  ///////// end set target
  ////// start select language

  toggleTooltip() {
    this.isTooltipVisible = !this.isTooltipVisible;
  }

  ////// start select language
  public selectus() {
    this.selectuslanaguge = true;
    this.selectuklanague = false;
    this.selectcalanaguage = false;
    this.selectaulanaguge = false;
  }
  public selectuk() {
    this.selectuklanague = true;
    this.selectuslanaguge = false;
    this.selectcalanaguage = false;
    this.selectaulanaguge = false;
  }
  public selectca() {
    this.selectuklanague = false;
    this.selectuslanaguge = false;
    this.selectcalanaguage = true;
    this.selectaulanaguge = false;
  }
  public selectau() {
    this.selectuklanague = false;
    this.selectuslanaguge = false;
    this.selectcalanaguage = false;
    this.selectaulanaguge = true;
  }
  //////// end select lanaguge
  ////// set target value/////

  public generalvalue(value: string) {
    this.settargetvalue = false;
    this.showAcademic = false;
    this.formalityvalue = 'formal';

    this.activeButton = value;
  }

  public acadmicvalues(value: string) {
    this.settargetvalue = true;
    this.showAcademic = true;
    this.activeButton = value;
    this.formalityvalue = 'formal';
  }

  public formalvalue(val) {
    if (!this.settargetvalue) {
      this.formvalueset = true;
      this.changeformalbg = true;
      this.formalityvalue = 'formal';
    }
  }
  public informalvalue(val) {
    if (!this.settargetvalue) {
      this.formvalueset = false;
      this.changeformalbg = false;
      this.formalityvalue = 'informal';
    }
  }
  setFormality(formality: string) {
    this.formality = formality;
  }

  setIntent(intent: string) {
    this.intent = intent;
  }
  setActiveButton(button: string) {
    this.activeButton = button;
  }

  ///// end all suggestion options
  ///// open tools menu

  openScope() {
    this.isModalOpen = true;
    this.isDropdownOpen = false;
    $('.bd-example-modal-lg-scope').modal('show');
  }

  openTarget() {
    this.isDropdownOpen = false;
    this.isOpenModal = true;
    $('.bd-example-modal-lg').modal('show');
  }

  closeModal() {
    this.isModalOpen = false;
  }

  ModelClose() {
    this.isOpenModal = false;
  }

  profile_id;
  isTextAreaFocused: boolean = false;
  words;
  editortxt = '';

  @HostListener('document:click', ['$event'])
  clickOut(event: Event) {
    if (!this.el.nativeElement.contains(event.target)) {
      this.isMenuDropdownVisible = false;
    }
  }

  quillEditor: any;

  onEditorCreated(quillInstance: Quill) {
    this.quillEditor = quillInstance;

    this.quillEditor.on('text-change', (delta, oldDelta, source) => {
      if (source === 'user') {
        this.updateEditorContent();
      }
    });

    this.updateEditorContent();
    this.onHandleFormatting(this.quillEditor);
  }
  updateEditorContent() {
    if (!this.quillEditor) return;

    this.homeText = this.quillEditor.root.innerHTML;
    this.char_count = this.quillEditor.getText().trim().length;
    this.word_count = this.quillEditor
      .getText()
      .trim()
      .split(/\s+/)
      .filter((word) => word.length > 0).length;
  }
  convertTablesToParagraphs(html: string): string {
    const doc = new DOMParser().parseFromString(html, 'text/html');

    doc.querySelectorAll('table').forEach((table) => {
      let newParagraphs = '';

      table.querySelectorAll('tr').forEach((row) => {
        let rowText: string[] = [];

        row.querySelectorAll('td, th').forEach((cell) => {
          rowText.push(cell.textContent?.trim() || '');
        });

        newParagraphs += `<p>${rowText.join(' | ')}</p>`;
      });

      const wrapper = document.createElement('div');
      wrapper.innerHTML = newParagraphs;
      table.replaceWith(...Array.from(wrapper.childNodes));
    });

    return doc.body.innerHTML;
  }
  public saveTextRedirect() {
    $('#editor').find('span').contents().unwrap();

    this.editortxt = this.quillEditor.scroll.domNode.innerHTML;
    setTimeout(() => {
      this.quill.root.querySelectorAll('img').forEach((img) => img.remove());
    }, 0);

    // if (
    //   this.editortxt !=
    //   'Upload Your ContentType or Paste AI Text hereSample TextPaste text'
    // )
    const localizedText = this.translate.instant(
      'alerts.Upload-Your-ContentType'
    );

    if (this.editortxt !== localizedText) {
      this.char_count = $('#editor').text().length;
      this.word_count = $('#editor').text().trim().split(/\s+/).length;

      const trimmedText = this.editortxt.trim();
      if (trimmedText.length === 0) {
        // this.showAlert('Error: Input is empty or only spaces.', '');
        this.translate
          .get('alerts.Input-is-empty')
          .subscribe((translatedMsg: string) => {
            this.showAlert(translatedMsg, '');
          });

        return;
      } else {
        if (this.editortxt.length > 0) {
          this.loaderAlert = true;
          let data2 = JSON.stringify({
            homeText: this.convertTablesToParagraphs(this.editortxt),
            profile_id: this.profile_id,
          });

          let url = environment.API_URL + '/api/getNewDocIDForGuestByContents';

          this.webservices.postResources(data2, url).subscribe((data) => {
            let receivedData = data;
            var editortxt = '';
            editortxt = this.convertTablesToParagraphs(this.homeText);

            localStorage.setItem('editorValueAI', editortxt);

            this.doc_id = receivedData['new_doc_id'];

            this.router.navigate(['/grammar-check'], {
              queryParams: { doc: this.doc_id },
            });

            const url = this.router.serializeUrl(
              this.router.createUrlTree([''])
            );
            // }
          });
        }
      }
    } else {
      // this.showAlert('Error: Please add atleast 1 word to proceed.', '');
      this.translate
        .get('alerts.Please-add')
        .subscribe((translatedMsg: string) => {
          this.showAlert(translatedMsg, '');
        });
    }
  }

  @ViewChild('editor') textDivRef!: ElementRef;

  deleteText() {
    $('.ql-editor').html('');
    this.loaderAlert = true;

    if (this.quill) {
      this.quill.setContents([]);
    }

    this.homeText = '';
    this.word_count = 0;
    this.char_count = 0;

    this.showParagraph = true;
    this.loaderAlert = false;
  }

  public handleNewDocData(data) {
    if (data.status === 200) {
      let receivedData = data.json();
      this.doc_id = receivedData['new_doc_id'];
      // this.router.navigate(['/document/', this.doc_id]);
      this.router.navigate(['/grammar-check'], {
        queryParams: { doc: this.doc_id },
      });
    }
  }
  //////////  Go to editor
  public gotoeditor(type) {
    let data2 = JSON.stringify({
      homeText: this.homeText,
      profile_id: this.profile_id,
    });
    let url = environment.API_URL + '/api/getNewDocIDForGuestByContents';
    this.webservices.postResources(data2, url).subscribe((data) => {
      let receivedData = data;
      this.doc_id = receivedData['new_doc_id'];
      // this.router.navigate(['/document/', this.doc_id]);
      this.router.navigate(['/grammar-check'], {
        queryParams: { doc: this.doc_id },
      });
      var editortxt = '';
      editortxt = this.homeText;
      localStorage.setItem('editorValueAI', editortxt);
      const url = this.router.serializeUrl(this.router.createUrlTree(['']));
    });
  }

  public mobilescreen: boolean = false;
  public responseformodbile: boolean = false;
  public getBrowserWidth = function () {
    if (window.innerWidth <= 430) {
      this.mobilescreen = true;
      this.responseformodbile = false;

      return 'xs';
    } else if (window.innerWidth < 991) {
      this.mobilescreen = true;
      this.responseformodbile = false;

      return 'sm';
    } else if (window.innerWidth < 1199) {
      this.mobilescreen = true;
      this.responseformodbile = false;

      return 'md';
    } else {
      this.mobilescreen = false;
      this.responseformodbile = false;
      return 'lg';
    }
  };

  public getContent(event, text) {
    this.copiedtext = false;
    var ctrlDown = false,
      ctrlKey = 17,
      cmdKey = 91,
      vKey = 86,
      cKey = 67;
    this.editortext = text;
    this.char_count = $('#editor').text().length;
    this.word_count = $('#editor').text().split(/\s+/).length;
    if (ctrlDown && event.keyCode == vKey) {
      this.showParagraph = false;
      var editortxt = $('#editor').text();
    }
    var editortxt = $('#editor').text();
    this.handleCheckGrammarButton();
  }
  currentTab: string = 'tab1';

  currenttoggleTab(tab: string): void {
    this.currentTab = this.currentTab === tab ? '' : tab;
  }
  getImageSrc(): string {
    switch (this.currentTab) {
      case 'tab1':
        return '../../assets/images/free-grammarchecker/Writers and Authors.webp';
      case 'tab2':
        return '../../assets/images/free-grammarchecker/Language Learners.svg';
      case 'tab3':
        return '../../assets/images/free-grammarchecker/Students & Teachers.svg';
      case 'tab4':
        return '../../assets/images/free-grammarchecker/Business Professionals.svg';
      case 'tab5':
        return '../../assets/images/free-grammarchecker/Website Owners.svg';
      default:
        return '../../assets/images/free-grammarchecker/Writers and Authors.webp';
    }
  }
  getIcon(tab: string): string {
    return this.currentTab === tab
      ? '../../assets/images/free-grammarchecker/up arrow.svg'
      : '../../assets/images/free-grammarchecker/down arrow.svg';
  }

  //  array array arrray

  executeAction(action: string) {
    if (this[action] && typeof this[action] === 'function') {
      this[action]();
    } else {
      // console.error(`Action "${action}" is not a valid method.`);
    }
  }

  contentArray = [
    {
      showParagraph: true,
      header: 'grammarPage.upload',
      paragraph: 'grammarPage.upload-p',
      buttons: [
        // {
        //   text: 'Sample Text',
        //   icon: 'copyIcon',
        //   action: 'sampletext',
        // },
        {
          text: 'grammarPage.upload-title',
          icon: 'copyIcon',
          action: 'sampletext',
        },
        {
          text: 'grammarPage.upload-title2',
          icon: 'copyIcon',
          action: 'pasteText',
        },
      ],
    },
  ];

  steps = [
    {
      icon: 'uploadFileicon',
      title: 'grammarPage.How-to-Use-title1',
      description: 'grammarPage.How-to-Use-title1-detail',
    },
    {
      icon: 'initiateCheckIcon',
      title: 'grammarPage.How-to-Use-title2',
      description: 'grammarPage.How-to-Use-title2-detail',
    },
    {
      icon: 'correctMistakesIcon',
      title: 'grammarPage.How-to-Use-title3',
      description: 'grammarPage.How-to-Use-title3-detail',
    },
    {
      icon: 'downloadResultsIcon',
      title: 'grammarPage.How-to-Use-title4',
      description: 'grammarPage.How-to-Use-title4-detail',
    },
  ];

  features = [
    {
      id1: 'checktitle',
      id2: 'checkp',
      icon: 'checkIcon',
      title: 'grammarPage.checktitle',
      description: 'grammarPage.checkp',
    },
    {
      id1: 'aibasetitle',
      id2: 'aibaseptag',
      icon: 'AIbasedIcon',
      title: 'grammarPage.aibasetitle',
      description: 'grammarPage.aibaseptag',
    },
    {
      id1: 'languagetitle',
      id2: 'languagep',
      icon: 'languageIcon',
      title: 'grammarPage.languagetitle',
      description: 'grammarPage.languagep',
    },
    {
      id1: 'Unlimited',
      id2: 'Unlimitedp',
      icon: 'unlimitedIcon',
      title: 'grammarPage.Unlimited',
      description: 'grammarPage.Unlimitedp',
    },
  ];
  //  array array arrray

  // ----------paste method --------

  pasteText(): void {
    navigator.clipboard
      .read()
      .then((clipboardItems) => {
        for (const item of clipboardItems) {
          for (const type of item.types) {
            if (type === 'text/html') {
              item.getType(type).then((blob) => {
                blob.text().then((html) => {
                  this.showParagraph = false;

                  const tempDiv = document.createElement('div');
                  tempDiv.innerHTML = html;

                  tempDiv
                    .querySelectorAll('script')
                    .forEach((script) => script.remove());

                  // Remove all <img> elements
                  tempDiv
                    .querySelectorAll('img')
                    .forEach((img) => img.remove());
                  tempDiv
                    .querySelectorAll('video')
                    .forEach((video) => video.remove());
                  tempDiv
                    .querySelectorAll('iframe')
                    .forEach((iframe) => iframe.remove());

                  tempDiv.querySelectorAll('*').forEach((el) => {
                    const element = el as HTMLElement;
                    element.removeAttribute('id');
                    element.removeAttribute('class');

                    if (element.style.backgroundImage) {
                      element.style.backgroundImage = 'none';
                    }

                    element.style.background = 'none';
                    element.style.backgroundColor = 'transparent';
                    element.style.color = 'black';
                  });
                  const emojiRegex =
                    /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/gu;
                  let modifiedContent = tempDiv.innerHTML.replace(
                    emojiRegex,
                    ''
                  );
                  // const modifiedContent = tempDiv.innerHTML;
                  if (this.quill) {
                    this.quill.clipboard.dangerouslyPasteHTML(
                      this.quill.getSelection()?.index || 0,
                      modifiedContent
                    );

                    setTimeout(() => {
                      this.char_count = this.quill.getText().length;
                      this.word_count = this.quill
                        .getText()
                        .trim()
                        .split(/\s+/).length;
                    }, 100);
                  }
                });
              });
              return;
            }
          }
        }
      })
      .catch((err) => {
        // console.error("Failed to read clipboard contents: ", err);
      });
  }

  quill: Quill | undefined;
  onHandleFormatting(quillInstance: Quill) {
    this.quill = quillInstance;

    this.quill.root.addEventListener('paste', (event: ClipboardEvent) => {
      event.preventDefault();

      this.showParagraph = false;

      setTimeout(() => {
        let quillContent = this.quill.root.innerHTML;

        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = quillContent;

        tempDiv
          .querySelectorAll('input[type="checkbox"], input[type="radio"]')
          .forEach((input) => input.remove());
        tempDiv
          .querySelectorAll('app-icons-free-tools')
          .forEach((icon) => icon.remove());
        tempDiv
          .querySelectorAll('script, img, svg, video, iframe, embed')
          .forEach((el) => el.remove());

        tempDiv.querySelectorAll('iframe').forEach((iframe) => {
          const src = (iframe as HTMLIFrameElement).src;
          if (src.includes('youtube.com') || src.includes('youtu.be')) {
            iframe.remove();
          }
        });

        tempDiv.querySelectorAll('*').forEach((el) => {
          const element = el as HTMLElement;
          element.style.background = 'none';
          element.style.backgroundColor = 'transparent';
          element.style.color = 'black';
          element.removeAttribute('id');
          element.removeAttribute('class');
        });

        const emojiRegex =
          /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/gu;
        let modifiedContent = tempDiv.innerHTML
          .replace(emojiRegex, '')
          .replace(/\s+/g, ' ')
          .trim();

        this.quill.setContents([]);
        this.quill.clipboard.dangerouslyPasteHTML(0, modifiedContent);

        this.sanitizedContent = this.sanitizer.bypassSecurityTrustHtml(
          tempDiv.innerHTML
        );

        setTimeout(() => {
          this.char_count = this.quill.getText().length;
          this.word_count = this.quill.getText().trim().split(/\s+/).length;
        }, 100);

        this.removeImagesFromQuill();
        this.handleCheckGrammarButton();

        for (let i = 0; i <= 100; i += 10) {
          setTimeout(
            () => {
              this.quill.root
                .querySelectorAll('img')
                .forEach((img) => img.remove());
            },
            i ? 5 : 0
          );
        }
      }, 0);
    });
  }

  removeImagesFromQuill() {
    setTimeout(() => {
      this.quill.root.querySelectorAll('img').forEach((img) => img.remove());
    }, 0);
  }

  sanitizedContent: SafeHtml;
  handleCheckGrammarButton() {
    if (!this.quillEditor || !this.quillEditor.root) {
      console.error(
        'Quill editor is not initialized yet. Retrying in 100ms...'
      );
      setTimeout(() => this.handleCheckGrammarButton(), 100);
      return;
    }

    this.quillEditor.root
      .querySelectorAll('img')
      .forEach((img) => img.remove());

    setTimeout(() => {
      if (this.quillEditor.root.innerText.trim().length === 0) {
        this.quillEditor.root
          .querySelectorAll('img')
          .forEach((img) => img.remove());
        this.quillEditor.enable();
      }
    }, 0);
  }
  // ----------paste method --------
  count_Words_Character2() {
    this.char_count = this.quillEditor.getText().trim().length;
    this.word_count = this.quillEditor
      .getText()
      .trim()
      .split(/\s+/)
      .filter((word) => word.length > 0).length;
    this.char_count = $('.ql-editor').text().length;
    this.word_count = $('.ql-editor').text().split(/\s+/).length;
  }
  private addEventListeners() {
    if (!this.quillEditor) return;

    const q = this.quillEditor;

    q.on('text-change', () => {
      this.count_Words_Character2();
      this.showParagraph = false;

      if (localStorage.getItem('file_uploaded')) {
        this.handleCheckGrammarButton();
      }
    });

    q.root.addEventListener('click', (event: MouseEvent) => {
      this.onclickeditor(event);
    });

    // q.root.addEventListener('keyup', (event: KeyboardEvent) => {
    //   this.handleTextChange(event);
    // });

    // q.root.addEventListener('paste', (event: ClipboardEvent) => {
    //   this.handleCheckGrammarButton();
    // });
  }
  @ViewChild('editor', { static: true }) editorElement!: ElementRef;
  private initializeEditor(quillModule: any, quillImport: any) {
    const Quill = quillImport.default;

    const editorConfig = {
      modules: {
        toolbar: {
          // container: this.toolbarElement.nativeElement,
        },
      },
      placeholder: '',
      theme: 'snow',
    };

    // this.quillEditor = new Quill(
    //   this.editorElement.nativeElement,
    //   editorConfig
    // );

    // this.quillEditor.root.id = 'editor';

    this.addEventListeners();
  }
  private loadEditor() {
    if (isPlatformBrowser(this.platformId)) {
      this.ngZone.runOutsideAngular(() => {
        import('ngx-quill').then((module) => {
          import('quill').then((quillModule) => {
            this.ngZone.run(() => {
              this.initializeEditor(module, quillModule);
              this.addEventListeners();
            });
          });
        });
      });
    }
  }

  getLocalizedImagePath(imageBaseName: string): string {
    const lang = this.languageService.selectedLanguage?.code || 'en';
    return lang === 'en'
      ? `/assets/images/illustration/${imageBaseName}-${lang}.svg`
      : `/assets/images/illustration/${imageBaseName}-${lang}.svg`;
  }

  @ViewChild('landerContainer', { read: ViewContainerRef, static: false }) landerContainer!: ViewContainerRef;
  landerComponentRef: ComponentRef<any> | null = null;
  isLanderLoaded = false;

  async loadLanderComponent() {
    if (this.isLanderLoaded || !this.landerContainer) return;
    const { LanderComponent } = await import('../grammarchecker/additional/lander.component');
    this.landerComponentRef = this.landerContainer.createComponent(LanderComponent);
    this.isLanderLoaded = true;
  }

}
